import React, { useState, useEffect } from "react";

const ROTATING_LABELS = [
  "New Projects in Pune",
  "Upcoming Residential Projects",
  "Luxury Apartments in Pune",
  "New Launch Opportunities",
];

// Rotating hero using ONLY verified project imagery from the database.
// Smooth cross-fade, preloads the next image, shows a subtle contextual overlay.
export default function HeroCarousel({ slides = [], intervalMs = 5000 }) {
  const [idx, setIdx] = useState(0);
  const n = slides.length;

  useEffect(() => {
    if (n <= 1) return undefined;
    const t = setInterval(() => setIdx((i) => (i + 1) % n), intervalMs);
    return () => clearInterval(t);
  }, [n, intervalMs]);

  useEffect(() => {
    if (n <= 1) return;
    const img = new Image();
    img.src = slides[(idx + 1) % n].image;
  }, [idx, n, slides]);

  if (n === 0) {
    return <div className="absolute inset-0 bg-gradient-to-br from-primary to-[#122a22]" aria-hidden />;
  }

  const current = slides[idx];

  return (
    <div className="absolute inset-0 overflow-hidden" data-testid="hero-carousel">
      {slides.map((s, i) => (
        <div key={s.image + i} aria-hidden={i !== idx}
          className="absolute inset-0 transition-opacity duration-[1200ms] ease-in-out"
          style={{ opacity: i === idx ? 1 : 0 }}>
          <img src={s.image} alt={s.alt || "Verified Pune residential project"} referrerPolicy="no-referrer"
            className="h-full w-full object-cover" loading={i === 0 ? "eager" : "lazy"} />
        </div>
      ))}
      <div className="absolute bottom-5 right-5 z-10 hidden sm:flex items-center gap-2 rounded-full bg-black/45 backdrop-blur px-4 py-2 text-xs text-white/90 border border-white/15"
        data-testid="hero-context">
        <span className="h-1.5 w-1.5 rounded-full bg-accent" aria-hidden />
        {current.projectName ? (
          <span><span className="font-semibold">{current.projectName}</span> · {current.location}</span>
        ) : (
          <span>{ROTATING_LABELS[idx % ROTATING_LABELS.length]}</span>
        )}
      </div>
    </div>
  );
}
